const ConsultationBody = () => {
  return (
    <section>
      <div>
       
      </div>
    </section>
  );
};

export default ConsultationBody;
